/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_NoteInputs */

const en_directory_external_directories_note = /** @type {(inputs: Directory_External_Directories_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DR values are editorial estimates refreshed periodically; link policies are verified at listing time.`)
};

const zh_directory_external_directories_note = /** @type {(inputs: Directory_External_Directories_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DR 为编辑定期校准的估计值；链接属性以实际收录时核验为准。`)
};

/**
* | output |
* | --- |
* | "DR values are editorial estimates refreshed periodically; link policies are verified at listing time." |
*
* @param {Directory_External_Directories_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_note = /** @type {((inputs?: Directory_External_Directories_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_note(inputs)
	return zh_directory_external_directories_note(inputs)
});
export { directory_external_directories_note as "directory.external_directories.note" }